/// <amd-module name="Feed/CreateFeed/Redux/CreateFeed/CreateFeedActions" />
import { ActionsUnion, createAction, trackedAction, trackedErrorAction } from "redux/Utils/ActionHelper";

import { ICreateFeedData } from "Feed/CreateFeed/Types";

export const enum CreateFeedActionTypes {
    // User Actions
    CreateFeed = "Feed/CreateFeed/CreateFeed",

    // API Actions
    SaveStarted = "#api/Feed/CreateFeed/SaveCreateFeed_Started",
    SaveCompleted = "#api/Feed/CreateFeed/SaveCreateFeed_Completed",
    SaveFailed = "#api/Feed/CreateFeed/SaveCreateFeed_Failed",

    // UI Actions
    SetError = "UI/CreateFeed/Error"
}

export const CreateFeedActions = {
    // User Actions
    createFeed: (data: ICreateFeedData) => trackedAction(createAction(CreateFeedActionTypes.CreateFeed, { data })),

    // API Actions
    saveStarted: () => createAction(CreateFeedActionTypes.SaveStarted),
    saveCompleted: () => createAction(CreateFeedActionTypes.SaveCompleted),
    saveFailed: (errorMessage: string | undefined) =>
        trackedErrorAction(createAction(CreateFeedActionTypes.SaveFailed, { errorMessage })),

    // UI Actions
    setError: (errorMessage: string | undefined) => createAction(CreateFeedActionTypes.SetError, { errorMessage })
};

export type CreateFeedActions = ActionsUnion<typeof CreateFeedActions>;
